import React, { useState, useEffect, useMemo, useContext } from 'react';

import cloudez_icon from 'assets/img/svg/cloud_cloudez.svg';

import { Row, Col } from 'react-bootstrap';

import SearchBar from 'components/SearchBar';
import { Pagination, createPagination } from '@cloudez/cloudez-design-system';

import { getCloudsService } from 'services/cloud';
import { Wrapper, CloudCard, Content, Logo } from './styles';
import { DatabaseCreateContext } from '../_context/state';
import CloudPlaceholder from './Placeholder';

const Cloud = () => {
  const { newDatabase, updateField } = useContext(DatabaseCreateContext);

  const [cloud, setCloud] = useState(null);
  const [search, setSearch] = useState<any>(null);
  const [cloudLoading, setCloudLoading] = useState(false);

  const getCloudsCallback = async (page, search) => {
    setCloudLoading(true);
    try {
      const { data } = await getCloudsService({
        page_size: 12,
        page,
        search,
      });

      const pagination = createPagination(data, 12);
      setCloud({ clouds: data.results, ...pagination });
      setCloudLoading(false);
    } catch (e) {
      setCloudLoading(false);
    }
  };

  useEffect(() => {
    getCloudsCallback(1, '');
  }, []);

  const searchValue = searchValue => {
    getCloudsCallback(1, searchValue);
  };

  const noResults = useMemo(() => cloud?.clouds?.length === 0, [cloud]);

  return (
    <Wrapper>
      <Row>
        <SearchBar
          callback={searchValue}
          noResults={noResults}
          value={search}
        />
      </Row>
      {cloudLoading ? (
        <CloudPlaceholder />
      ) : (
        <>
          <Row
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {cloud?.clouds?.map(c => (
              <Col
                key={c.id}
                lg="2"
                md="3"
                sm="4"
                xs="6"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <CloudCard
                  key={c.id}
                  selected={c.id === newDatabase.cloud}
                  onClick={() => updateField('cloud', c.id)}
                >
                  <Content>
                    <Logo>
                      <img src={cloudez_icon} width="45px" alt="logo" />
                    </Logo>
                  </Content>
                  <span>{c.nickname || c.name}</span>
                  <p>
                    {c.cloud_size.name} {c.cloud_size.disk}
                  </p>
                </CloudCard>
              </Col>
            ))}
          </Row>
          <Row>
            <Pagination
              onChangePage={getCloudsCallback}
              pageSize={12}
              search={search}
              count={cloud?.count}
              previous={cloud?.previous}
              next={cloud?.next}
              current={cloud?.current}
            />
          </Row>
        </>
      )}
    </Wrapper>
  );
};

export default Cloud;
